import { Stack } from "@mui/material";

import { useTranslate } from "@/common/hooks/useTranslate";
import { FormTypography } from "@/forms-design-system/FormTypography";

export type AdditionalQuestionsForTicketProps = {
  itemType: "ticket" | "item" | "membership";
  isEntry?: boolean;
  purchasedAmount: number;
  groupNumber: number;
  participantNumber: number;
  isPartOfGroupTicket: boolean;
  children: React.ReactNode;
};

export const AdditionalQuestionsForTicket = ({
  purchasedAmount,
  itemType,
  isEntry = false,
  isPartOfGroupTicket,
  groupNumber,
  participantNumber,
  children,
}: AdditionalQuestionsForTicketProps) => {
  const { t } = useTranslate();

  const formCategoryLabel =
    itemType === "item" ? t("ticketing", "item") : isEntry ? t("ticketing", "entry") : t("ticketing", "ticket");

  const getTicketHeaderLabel = () => {
    if (purchasedAmount > 1) {
      if (isPartOfGroupTicket) {
        return `${t("ticketing", "groupTicket")} ${groupNumber} - ${formCategoryLabel} #${participantNumber}`;
      } else {
        return `${formCategoryLabel} #${groupNumber}`;
      }
    }

    if (isPartOfGroupTicket) {
      return `${formCategoryLabel} #${participantNumber}`;
    }

    return "";
  };

  const ticketHeaderLabel = getTicketHeaderLabel();

  return (
    <Stack data-test="questions-one-group" gap={1}>
      {ticketHeaderLabel && (
        <FormTypography variant="subtitle2" vibe="supershy">
          {ticketHeaderLabel}
        </FormTypography>
      )}
      <Stack gap={2}>{children}</Stack>
    </Stack>
  );
};
